/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Cookies_DescriptionInputs */

const en_analytics_cookies_description = /** @type {(inputs: Analytics_Cookies_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product analytics that help us understand usage. Off until you allow it.`)
};

const es_analytics_cookies_description = /** @type {(inputs: Analytics_Cookies_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analítica de producto que nos ayuda a entender el uso. Desactivada hasta que la permitas.`)
};

const fr_analytics_cookies_description = /** @type {(inputs: Analytics_Cookies_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytique produit qui nous aide à comprendre l'usage. Désactivée tant que vous ne l'autorisez pas.`)
};

/**
* | output |
* | --- |
* | "Product analytics that help us understand usage. Off until you allow it." |
*
* @param {Analytics_Cookies_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const analytics_cookies_description = /** @type {((inputs?: Analytics_Cookies_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Cookies_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_analytics_cookies_description(inputs)
	if (locale === "es") return es_analytics_cookies_description(inputs)
	return fr_analytics_cookies_description(inputs)
});